export default "__VITE_ASSET__DcMqcX9d__"